// Bundle Pack Configuration
// Set to 'ON' to enable the bundle offer banner, 'OFF' to disable it
export const BUNDLE_PACK = 'OFF' as const;

// Bundle pack configuration
export const BUNDLE_CONFIG = {
  enabled: BUNDLE_PACK === 'ON',
  courseId: 'bundle-completo',
  originalPrice: 599,
  offerPrice: 499,
  savings: 100,
} as const;
